export default "__VITE_ASSET__Cn01Kn4o__"